import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlErrorClassDirective } from '@finder/features/eve/directives/control-error-class.directive';
import '@wdpr/single-select';

@Component({
    selector: 'finder-ra-single-select',
    templateUrl: './ra-single-select.component.html',
    styleUrl: './ra-single-select.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [ControlErrorClassDirective],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
})
export class RaSingleSelectComponent {
    @Input() errorControlClass = 'has-error';
    @Input() disabled = false;
    @Input() showError;
    @Input() controlError;
    @Input() id;
    @Input() options;
    @Input() value;
    @Input() label;
    @Input() hidden;
    @Output() itemSelected = new EventEmitter<any>();

    onChange($event) {
        this.itemSelected.emit($event);
    }
}
